module.exports = __webpack_public_path__ + "11e05a2a48fccb8cc1bdf254c3172d80.png";